import * as React from "react"
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={280} height={230} {...props}>
    <title>{"facial-hair/Goatee 1"}</title>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M207.914 31.328c-11.12-5.009-31.09-.638-38.34 1.1-16.856 4.042-33.812 12.777-39.052 26.462-5.905 15.423 5.877 20.278 7.61 19.485 11.668.822 25.563-6.513 37.79-8.406 9.926-1.55 20.397-2.903 29.697-8.177 6.79 3.735 22.126 5.754 34.503 9.02 10.541 2.78 15.108 8.81 24.88 7.527 11.712-1.536 6.918-26.169-6.135-36.148-14.286-10.92-38.448-15.35-50.953-10.863Zm22.02 105.326c-9.73 2.372-10.383-18.953-11.473-26.487-.851-5.886-5.654-21.065-17.83-20.41-12.176.654-16.753 13.372-16.135 21.281.4 5.13 5.127 31.112-9.96 34.398-9.619-.034-20.747-.683-30.86-2.548-11.905-2.696-27.384-12.135-31.473 6.454-1.471 6.69 50.966 26.567 74.235 28.365 23.598 4.783 51.209-2.57 68.01-20.623 3.822-4.107 14.588-21.154 15.355-25.33 1.611-8.776-2.12-14.422-12.978-11.33-7.67 4.096-20.634 14.704-26.89 16.23Z"
    />
  </svg>
)
export default SvgComponent
